import { useEffect, useState } from "react";
import { ImageListItem } from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import {
	ActiveImage,
	Container,
	ItemImage,
	NextIconButton,
	PreviousIconButton,
	Thumbnail,
	Thumbnails,
	ThumbnailsContainer
} from "features/MarketingMaterials/pages/ItemDetails/components/ItemImageCarousel.styles.ts";

export interface ItemImageCarouselProps {
	images: string[];
}

export const ItemImageCarousel = ({ images }: ItemImageCarouselProps) => {
	const [activeIndex, setActiveIndex] = useState(0);

	useEffect(() => {
		setActiveIndex(0);
	}, [images]);

	if (!images?.length) {
		return null;
	}

	const hasMultipleImages = images.length > 1;

	const goToPrevious = () => {
		setActiveIndex((currentIndex) => (currentIndex === 0 ? images.length - 1 : currentIndex - 1));
	};

	const goToNext = () => {
		setActiveIndex((currentIndex) => (currentIndex === images.length - 1 ? 0 : currentIndex + 1));
	};

	return (
		<Container data-testid="item-image-carousel">
			<ActiveImage>
				{hasMultipleImages && (
					<PreviousIconButton
						onClick={goToPrevious}
						aria-label="Previous image"
					>
						<ArrowBackIosNewIcon fontSize="small" />
					</PreviousIconButton>
				)}
				<ItemImage
					src={images[activeIndex]}
					alt={`Product image ${activeIndex + 1}`}
				/>
				{hasMultipleImages && (
					<NextIconButton
						onClick={goToNext}
						aria-label="Next image"
					>
						<ArrowForwardIosIcon fontSize="small" />
					</NextIconButton>
				)}
			</ActiveImage>
			<ThumbnailsContainer
				cols={Math.min(images.length, 5)}
				gap={8}
			>
				{images.map((image, index) => (
					<ImageListItem key={`${image}-${index}`}>
						<Thumbnails
							component="button"
							type="button"
							onClick={() => setActiveIndex(index)}
							aria-label={`View image ${index + 1}`}
							index={index}
							activeIndex={activeIndex}
						>
							<Thumbnail
								component="img"
								src={image}
								alt={`Thumbnail ${index + 1}`}
							/>
						</Thumbnails>
					</ImageListItem>
				))}
			</ThumbnailsContainer>
		</Container>
	);
};
